import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import U2000InputTextBase from '../../u2000Core/components/formControls/input/U2000InputTextBase';
import U2000SaveCancelDialog from '../../u2000Core/components/dialog/U2000SaveCancelDialog';
import { NS } from '../U3204';

interface U3204ConversationRenameDlgProps {
  isOpen: boolean;
  initialTitle: string;
  onClose: () => void;
  onSave: (title: string) => Promise<boolean>;
}

const U3204ConversationRenameDlg: React.FC<U3204ConversationRenameDlgProps> = ({
  isOpen,
  initialTitle,
  onClose,
  onSave,
}) => {
  const { t } = useTranslation(NS);
  const [title, setTitle] = useState(initialTitle);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setTitle(initialTitle);
    }
  }, [initialTitle, isOpen]);

  const trimmed = title.trim();
  const isValid = trimmed.length > 0;

  const handleClose = async (action: 'save' | 'cancel') => {
    if (action === 'cancel' || saving) {
      onClose();
      return;
    }

    setSaving(true);
    try {
      const ok = await onSave(trimmed);
      if (ok) onClose();
    } finally {
      setSaving(false);
    }
  };

  return (
    <U2000SaveCancelDialog
      isOpen={isOpen}
      onClose={handleClose}
      title={t('renameDialogTitle', { ns: NS })}
      isValid={isValid && !saving}
      width="medium"
    >
      <U2000InputTextBase
        fieldName="conversationTitle"
        label={t('rename', { ns: NS })}
        value={title}
        setValue={(v) => setTitle(String(v))}
        required
      />
    </U2000SaveCancelDialog>
  );
};

export default U3204ConversationRenameDlg;
